export const blogs = [
  {
    img_path: '/images/tcr-branding.jpg',
    url_endpoint: 'blogs/branding',
    intro_para: 'You can consider a brand as the idea or image people have in mind when thinking about specific products, services, and activities of a company, both in a practical (e.g. “the shoe is light-weight”) and emotional way...',
    date_published: 'February 12 2022',
    author: 'Sahitya Bishnoi',
    title: 'WHAT IS A BRAND?'
  }
];